import React from "react";

const Svg = ({width = 15}: {width?: number} = {}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1807_6729)">
        <path
          d="M15 7.4998C15 11.6419 11.6423 14.9996 7.5002 14.9996C3.35808 14.9996 0 11.6419 0 7.4998C0 3.35768 3.35768 0 7.4998 0C11.6419 0 14.9996 3.35768 14.9996 7.4998H15ZM6.99273 11.4982C6.80053 11.79 6.84272 12.1111 7.07126 12.3314C7.25916 12.5127 7.65411 12.601 7.8846 12.3705L12.3732 7.88655C12.5471 7.64318 12.5471 7.35604 12.3732 7.11267L7.90491 2.64708C7.66622 2.40878 7.27947 2.47011 7.06579 2.67286C6.86382 2.86468 6.77006 3.27252 7.00406 3.50652L10.3692 6.87319L3.09048 6.87593C2.72912 6.87593 2.49082 7.20838 2.50059 7.51582C2.51113 7.84593 2.7674 8.12368 3.12837 8.12407L10.3696 8.12563L6.99234 11.4978L6.99273 11.4982Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1807_6729">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Svg;
